module.exports = [
	{
		"plan": "developer",
		"name": "Developer",
		"planClass": "developer",
		"description": "Use any social identity providers to authenticate, manage users with a powerful dashboard, and customize and extend authentication processes programatically.",
		"button": {
			"text": "TRY IT FOR FREE",
			"customText": "CONTACT US"
		},
		"sliders": {
			"social": true,
			"developer": true
		},
		"showPrice": "",
		"subtitle": true
	},
	{
		"plan": "developer-pro",
		"name": "Developer Pro",
		"planClass": "developer-pro-external",
		"description": "Enterprise identity providers support, impersonation and additional security features including password complexity rules and multi-factor authentication among others.",
		"button": {
			"text": "TRY IT FOR FREE",
			"customText": "CONTACT US"
		},
		"sliders": {
			"social": true,
			"enterprise": true
		},
		"showPrice": "",
		"subtitle": true
	},
	{
		"plan": "developer-pro",
		"name": "Developer Pro",
		"planClass": "developer-pro-internal hide",
		"description": "Enterprise identity providers support, impersonation and additional security features including password complexity rules and multi-factor authentication among others.",
		"button": {
			"text": "TRY IT FOR FREE",
			"customText": "CONTACT US"
		},
		"sliders": {
			"employee": true
		},
		"showPrice": "",
		"subtitle": true
	},
	{
		"plan": "enterprise",
		"name": "Enterprise",
		"planClass": "enterprise",
		"description": "Ideal for your mission critical applications. Get a secure, universal identity platform that just works. High SLA environment with enterprise-grade support, SOC 2, HIPAA/BAA, Privacy Shield certifications and audit reports as well as private cloud or on-premise deployments.",
		"button": {
			"text": "TALK TO SALES",
			"customText": "TALK TO SALES"
		},
		"sliders": {},
		"showPrice": "",
		"subtitle": true
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/components/pricingPlans/dataplan.json
// module id = 1346
// module chunks = 0